// Auto-generated translation data (clBatch7) — Fase 3: UI secundaria/a11y (LC-10,11,17-28).
// Pure data only. Keys 1:1 es/en; namespace por defecto 'common'. pt usa fallback a es.

export const es = {
  specs: {
    title: 'Características',
    yes: 'Sí',
    no: 'No',
    showEnergyLabel: 'Ver etiqueta calificación energética',
    hideEnergyLabel: 'Ocultar etiqueta calificación energética',
    rows: {
      propertyType: 'Tipo de inmueble',
      availability: 'Disponibilidad',
      rentalType: 'Tipo de alquiler',
      operation: 'Operación',
      hotWater: 'Agua caliente',
      state: 'Estado',
      age: 'Antigüedad',
      garage: 'Garaje',
      floor: 'Planta',
      elevator: 'Ascensor',
      furnished: 'Amueblado',
      heating: 'Calefacción',
      energy: 'Energía',
      emissions: 'Emisiones',
    },
    type: { casa: 'Casa', departamento: 'Piso', oficina: 'Oficina', terreno: 'Terreno', bodega: 'Bodega' },
    operation: { venta: 'Venta', arriendo: 'Alquiler' },
    furnished: { yes: 'Sí', no: 'No', semi: 'Semiamueblado' },
    garage: { none: 'Sin garaje', private: 'Privado', communal: 'Comunitario' },
    rental: { long: 'Larga duración', short: 'Corta duración', temporal: 'Temporal' },
    availability: { unrestricted: 'Sin restricciones', reserved: 'Reservada', unavailable: 'No disponible' },
    age: {
      under5: 'menos de 5 años',
      from5to10: '5 a 10 años',
      from10to20: '10 a 20 años',
      from20to30: '20 a 30 años',
      from30to50: '30 a 50 años',
      from50to80: '50 a 80 años',
      over80: 'más de 80 años',
    },
    energy: {
      ratingLabel: 'Etiqueta de calificación energética:',
      consumption: 'Consumo',
      emissions: 'Emisiones',
      unitConsumption: 'kWh/m²·año',
      unitEmissions: 'kg CO₂/m²·año',
    },
  },
  energy: {
    certificateTitle: 'Certificado energético',
    efficiencyCertificateTitle: 'Certificado de eficiencia energética',
    energyConsumption: 'Consumo de energía',
    co2Emissions: 'Emisiones de CO₂',
    emissions: 'Emisiones',
    unitConsumption: 'kWh/m²·año',
    unitEmissions: 'kg CO₂/m²·año',
    scaleLegalNote: 'Escala según el Real Decreto 390/2021 sobre certificación energética de edificios.',
    ratingLabel: 'Etiqueta: {{rating}}',
  },
  legal: {
    heading: 'Información legal sobre el alquiler',
    defaultRentNotice: 'La normativa que regula el alquiler es la Ley de Arrendamientos Urbanos (LAU) y la legislación autonómica de vivienda aplicable. En zonas declaradas de mercado residencial tensionado el precio del alquiler se rige por el Índice de Referencia de Precios de Alquiler conforme al artículo 18 de la Ley 12/2023, de 24 de mayo, por el derecho a la vivienda. Si la vivienda ha estado alquilada en los últimos cinco años y el arrendador no es gran tenedor, se aplica la actualización legalmente procedente sobre la última renta vigente. Si no ha tenido contrato de alquiler en los últimos cinco años o el arrendador es gran tenedor, la renta se fija conforme al Índice de Referencia de Precios de Alquiler.',
  },
  propertyGrid: {
    emptyTitle: 'No se encontraron resultados',
    emptyHint: 'Intenta ajustar los filtros para encontrar más propiedades',
    discardedMessage: 'Has descartado este inmueble',
    restore: 'Recuperar',
    badgeSale: 'VENTA',
    badgeRent: 'ALQUILER',
    badgeFeatured: 'DESTACADO',
    addFavorite: 'Añadir a favoritos',
    removeFavorite: 'Quitar de favoritos',
    discardProperty: 'Descartar inmueble',
    locationUnavailable: 'Ubicación no disponible',
    viewDetails: 'Ver Detalles',
    bookVisit: 'Reservar visita',
    viewPhotos: 'Ver {{count}} fotos',
    closeGallery: 'Cerrar galería',
    prevPhoto: 'Foto anterior',
    nextPhoto: 'Foto siguiente',
    mainPhotoAlt: '{{title}} — foto principal',
    photoAlt: '{{title}} — foto {{number}}',
    goToPhoto: 'Ir a la foto {{number}}',
    noPhoto: 'Sin foto',
    operationSale: 'Venta',
    operationRent: 'Alquiler',
    operationShortStay: 'Corta estancia',
    bookAppointment: 'Reservar cita',
  },
  propertyCta: {
    contactActions: 'Acciones de contacto',
    call: 'Llamar',
    whatsapp: 'WhatsApp',
    email: 'Email',
    share: 'Compartir',
    shareNative: 'Compartir…',
    shareWhatsapp: 'WhatsApp',
    shareFacebook: 'Facebook',
    shareTwitter: 'X (Twitter)',
    shareTelegram: 'Telegram',
    shareEmail: 'Email',
    copied: '¡Copiado!',
    copyLink: 'Copiar enlace',
    copyLinkPrompt: 'Copia el enlace:',
    professionalAdvertiser: 'Anunciante profesional',
    verifiedAgency: 'Agencia verificada',
    callAgency: 'Llamar a la agencia',
    emailAgency: 'Escribir a la agencia',
    reference: 'Referencia:',
  },
  ui: {
    whatsappCta: 'Pide información por WhatsApp',
    whatsappMessage: 'Hola {{name}}, me gustaría que me dieseis más información sobre una propiedad.',
    errorTitle: 'Algo salió mal',
    comingSoon: 'Próximamente',
    contactPhone: 'Teléfono',
    contactEmail: 'Email',
    contactAddress: 'Dirección',
    noTeamMembers: 'No hay miembros del equipo disponibles',
    loading: 'Cargando…',
    retry: 'Reintentar',
    selectLanguage: 'Seleccionar Idioma',
  },
};

export const en = {
  specs: {
    title: 'Features',
    yes: 'Yes',
    no: 'No',
    showEnergyLabel: 'View energy performance label',
    hideEnergyLabel: 'Hide energy performance label',
    rows: {
      propertyType: 'Property type',
      availability: 'Availability',
      rentalType: 'Rental type',
      operation: 'Operation',
      hotWater: 'Hot water',
      state: 'Condition',
      age: 'Age',
      garage: 'Garage',
      floor: 'Floor',
      elevator: 'Elevator',
      furnished: 'Furnished',
      heating: 'Heating',
      energy: 'Energy',
      emissions: 'Emissions',
    },
    type: { casa: 'House', departamento: 'Flat', oficina: 'Office', terreno: 'Land', bodega: 'Warehouse' },
    operation: { venta: 'Sale', arriendo: 'Rent' },
    furnished: { yes: 'Yes', no: 'No', semi: 'Semi-furnished' },
    garage: { none: 'No garage', private: 'Private', communal: 'Communal' },
    rental: { long: 'Long-term', short: 'Short-term', temporal: 'Seasonal' },
    availability: { unrestricted: 'No restrictions', reserved: 'Reserved', unavailable: 'Not available' },
    age: {
      under5: 'less than 5 years',
      from5to10: '5 to 10 years',
      from10to20: '10 to 20 years',
      from20to30: '20 to 30 years',
      from30to50: '30 to 50 years',
      from50to80: '50 to 80 years',
      over80: 'more than 80 years',
    },
    energy: {
      ratingLabel: 'Energy performance rating:',
      consumption: 'Consumption',
      emissions: 'Emissions',
      unitConsumption: 'kWh/m²·year',
      unitEmissions: 'kg CO₂/m²·year',
    },
  },
  energy: {
    certificateTitle: 'Energy certificate',
    efficiencyCertificateTitle: 'Energy efficiency certificate',
    energyConsumption: 'Energy consumption',
    co2Emissions: 'CO₂ emissions',
    emissions: 'Emissions',
    unitConsumption: 'kWh/m²·year',
    unitEmissions: 'kg CO₂/m²·year',
    scaleLegalNote: 'Scale according to Royal Decree 390/2021 on the energy certification of buildings.',
    ratingLabel: 'Rating: {{rating}}',
  },
  legal: {
    heading: 'Legal information about the rental',
    defaultRentNotice: 'The rental is governed by the Urban Leases Act (Ley de Arrendamientos Urbanos, LAU) and the applicable regional housing legislation. In areas declared to be stressed residential markets, the rental price is set in accordance with the Reference Price Index for Rentals pursuant to Article 18 of Law 12/2023, of 24 May, on the right to housing. If the property has been rented within the last five years and the landlord is not a large holder, the update legally applicable to the last rent in force is applied. If it has not been under a rental agreement within the last five years, or the landlord is a large holder, the rent is set in accordance with the Reference Price Index for Rentals.',
  },
  propertyGrid: {
    emptyTitle: 'No results found',
    emptyHint: 'Try adjusting the filters to find more properties',
    discardedMessage: 'You\'ve dismissed this property',
    restore: 'Restore',
    badgeSale: 'FOR SALE',
    badgeRent: 'FOR RENT',
    badgeFeatured: 'FEATURED',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',
    discardProperty: 'Dismiss property',
    locationUnavailable: 'Location unavailable',
    viewDetails: 'View details',
    bookVisit: 'Book a viewing',
    viewPhotos: 'View {{count}} photos',
    closeGallery: 'Close gallery',
    prevPhoto: 'Previous photo',
    nextPhoto: 'Next photo',
    mainPhotoAlt: '{{title}} — main photo',
    photoAlt: '{{title}} — photo {{number}}',
    goToPhoto: 'Go to photo {{number}}',
    noPhoto: 'No photo',
    operationSale: 'Sale',
    operationRent: 'Rent',
    operationShortStay: 'Short stay',
    bookAppointment: 'Book an appointment',
  },
  propertyCta: {
    contactActions: 'Contact actions',
    call: 'Call',
    whatsapp: 'WhatsApp',
    email: 'Email',
    share: 'Share',
    shareNative: 'Share…',
    shareWhatsapp: 'WhatsApp',
    shareFacebook: 'Facebook',
    shareTwitter: 'X (Twitter)',
    shareTelegram: 'Telegram',
    shareEmail: 'Email',
    copied: 'Copied!',
    copyLink: 'Copy link',
    copyLinkPrompt: 'Copy the link:',
    professionalAdvertiser: 'Professional advertiser',
    verifiedAgency: 'Verified agency',
    callAgency: 'Call the agency',
    emailAgency: 'Email the agency',
    reference: 'Reference:',
  },
  ui: {
    whatsappCta: 'Request information via WhatsApp',
    whatsappMessage: 'Hi {{name}}, I\'d like more information about a property.',
    errorTitle: 'Something went wrong',
    comingSoon: 'Coming soon',
    contactPhone: 'Phone',
    contactEmail: 'Email',
    contactAddress: 'Address',
    noTeamMembers: 'No team members available',
    loading: 'Loading…',
    retry: 'Retry',
    selectLanguage: 'Select Language',
  },
};
